export function scoreFormat(score){
    if(!score || isNaN(score)) return 0
    if(score >= score.toPrecision(3)) {
        if(score % 1 === 0) return score.toString()
        return score.toFixed(2).toString()
    }
    return score.toPrecision(3)
}